module.exports = __webpack_public_path__ + "static/media/pic7.c37b6a63.webp";